import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const BreakoutLabel = styled.span`
  color: ${color("summarize")};
`;
